import { CommonGetOptions } from "interfaces/dataInterfaces"
import { householdApi } from "./householdApi"

export const attributesApi = householdApi.injectEndpoints({
  endpoints: builder => ({
    getAttributes: builder.query<CommonGetOptions[], void>({
      query: () => ({
        url: `Attributes/Get`,
        method: "GET",
      }),
      providesTags: ["Attributes"],
    }),

    addAttribute: builder.mutation<void, { name: string }>({
      query: ({ name }) => ({
        url: `Attributes/Add`,
        method: "POST",
        params: { name },
      }),
      invalidatesTags: ["Attributes"],
    }),

    editAttribute: builder.mutation<void, { id: number; name: string }>({
      query: ({ id, name }) => ({
        url: `Attributes/Put/${id}`,
        method: "PUT",
        params: { name },
      }),
      invalidatesTags: ["Attributes"],
    }),

    deleteAttribute: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `Attributes/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Attributes"],
    }),
  }),
})

export const {
  useGetAttributesQuery,
  useLazyGetAttributesQuery,
  useAddAttributeMutation,
  useEditAttributeMutation,
  useDeleteAttributeMutation,
} = attributesApi
